import { CounterCustomerChargeEntity } from "domain/entity/CounterCustomerCharge/CounterCustomerChargeEntity";
import _ from "lodash";
import { CounterCustomerChargeMaintenanceConstant } from "presentation/constant/CounterCustomerCharge/CounterCustomerChargeMaintenanceConstant";
import { useCounterCustomerChargeMaintenanceVM } from "presentation/hook/CounterCustomerCharge/useCounterCustomerChargeMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useCounterCustomerChargeMaintenanceTracked } from "presentation/store/CounterCustomerCharge/CounterCustomerChargeMaintenanceProvider";
import { HeaderTitle } from "presentation/view/components/HeaderWithBackButton/HeaderTitle";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useCallback, useMemo, useState } from "react";
import { FieldType, HPHButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, Sidebarheader } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const UpdateAccTerminalPanel = () => {
    const [counterCustomerChargeState] = useCounterCustomerChargeMaintenanceTracked();
    const counterCustomerChargeVM = useCounterCustomerChargeMaintenanceVM();
    const COUNTER_CUSTOMER_CHARGE_CONSTANT = CounterCustomerChargeMaintenanceConstant.Detail;
    const { editingEntity, allFormState } = counterCustomerChargeState;
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const messageBarVM = useMessageBarVM();

    const handleSaveClick = useCallback(async () => {
        if (_.isEmpty(counterCustomerChargeState.selectedRows)) {
            messageBarVM.showError('Please select record(s).');
            return;
        }
        setIsLoading(true);
        let entityList: CounterCustomerChargeEntity[] = [];
        counterCustomerChargeState.selectedRows.forEach(item => {
            item.accountTmlReasonCode = editingEntity?.accountTmlReasonCode;
            entityList.push(item);
        });
        await counterCustomerChargeVM.onValidationAccTerminal(entityList[0]).then(data => {
            if (data) {
                counterCustomerChargeVM.onAccTerminal(entityList).then((res) => {
                    if (res && res.success) {
                        messageBarVM.showSuccess('Save Successfully.');
                        counterCustomerChargeVM.onMoreClose();
                        counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria);
                    } else {
                        messageBarVM.showError('Save Failed.');
                    }
                    setIsLoading(false);
                });
            } else {
                setIsLoading(false);
            }
        })
    }, [counterCustomerChargeVM, counterCustomerChargeState.selectedRows, counterCustomerChargeState.searchCriteria, messageBarVM, editingEntity]);

    const handClose = useCallback(() => {
        counterCustomerChargeVM.onMoreClose();
    }, [counterCustomerChargeVM]);

    const memoAccountTml = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px", marginLeft: "15px" }}>
            <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px", marginLeft: "15px" }}>
                <NbisCommonField
                    errorMessage={allFormState ? allFormState["accountTmlReasonCode"] : ""}
                    isReadOnly={false}
                    isShowOptional={false}
                    readOnlyValue={editingEntity?.accountTmlReasonCode || ''}
                    fieldValue={editingEntity?.accountTmlReasonCode}
                    fieldLabel={COUNTER_CUSTOMER_CHARGE_CONSTANT.REASON_CODE}
                    fieldType={FieldType.DROPDOWN}
                    fieldKey={'accountTmlReasonCode'}
                    maxLength={60}
                    options={counterCustomerChargeState.dynamicOptions.acctTmlReasonCodeDropdownOptions}
                    requiredFieldList={[]}
                    onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                        counterCustomerChargeVM.onCounterCustomerFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
            </div>
        </div>
        , [allFormState, editingEntity?.accountTmlReasonCode, COUNTER_CUSTOMER_CHARGE_CONSTANT.REASON_CODE, counterCustomerChargeState.dynamicOptions.acctTmlReasonCodeDropdownOptions, counterCustomerChargeVM])


    return (<div className='side-form-content-left-wrapper' style={{ padding: "20px 20px 20px 0px" }}>
        <div className={'flex-row'}>
            <div className={'flex-row-item flex-row-item-full-width'}>
                <Sidebarheader>
                    <HeaderTitle>{"Account Terminal / Resume"}</HeaderTitle>
                </Sidebarheader>
            </div>
        </div>

        {isLoading && <Loader Indicator="Spinner" size="Medium" />}

        <div className={'add-edit-form'} style={{ maxHeight: '75vh', height: '75vh', overflow: 'auto' }}>
            <div className="flex-row-auto">
                <div className={'flex-row-item'}>
                    {memoAccountTml}
                </div>
            </div>
        </div>
        <SidebarActionBar>
            <HPHButton label={'Close'} size={'Small'} theme={'Secondary'} onClick={handClose} />
            <HPHButton label={'Save'} size={'Small'} theme={'Primary'} onClick={() => handleSaveClick()} />
        </SidebarActionBar>
    </div>)
}

export default memo(UpdateAccTerminalPanel);